import React, { Component } from 'react';
import { connect } from 'react-redux';
import NativeSelect from '@material-ui/core/NativeSelect';
import moment from 'moment';
import * as CashTeller from './Saga/CashTellers';

interface Props {
    shops: any,
    user_details: any,
    section: any,
    get_list: any,
    cash_tellers_list: any,
    SectionSave: any,
    DateSave: any,
    get_monthly: any,
    cash_teller_monthly: any,
    Reset: any,
    get_cash_teller_nowmonthly: any,
    cash_teller_nowmonthly: any,
    GetList: any
}
interface State {
    refresh: boolean,
    selectedDate: string,
    sectionState: Number
}

var shop = [{
    tenpoNo: 1,
    tenpoName: "番町店"
},
{
    tenpoNo: 2,
    tenpoName: "レインボーロード店"
},
{
    tenpoNo: 3,
    tenpoName: "高松駅前店"
},
{
    tenpoNo: 4,
    tenpoName: "高松東店"
},
{
    tenpoNo: 6,
    tenpoName: "高松中央公園店"
},
{
    tenpoNo: 17,
    tenpoName: "サンフラワー店"
},
{
    tenpoNo: 47,
    tenpoName: "中央通り店"
},
{
    tenpoNo: 5,
    tenpoName: "開発＆管理部"
},
{
    tenpoNo: 14,
    tenpoName: "工事部"
},
{
    tenpoNo: 100,
    tenpoName: "その他"
},
{
    tenpoNo: 101,
    tenpoName: "センター経理"
},
{
    tenpoNo: 102,
    tenpoName: "住研経理"
},
]



class Cashteller extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            refresh: false,
            selectedDate: moment(new Date()).format("YYYY-MM"),
            sectionState: 0
        }
        this.change = this.change.bind(this);
    }


    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));
        return
    }

    change = (e: any) => {
        // ここのチェンジが動くの経理だけなので、ここのvalueでデータを取ってくる
        this.setState({
            sectionState: e.target.value,
        });

        this.props.SectionSave(e.target.value);

        var data = {
            section: e.target.value,
            date: this.state.selectedDate
        }
        this.props.Reset();
        this.props.get_monthly(data);
        this.props.get_cash_teller_nowmonthly(data);
        // this.props.get_list(data);
    }


    date = (date: any) => {
        this.setState({
            selectedDate: date.target.value,
        });

        this.props.DateSave(date.target.value);

        var data: any;
        if (this.state.sectionState == 0) {

            // ↑が０なのは経理・徳本・システム以外の部署を指す
            // 賃貸それぞれの店舗
            // 上林・工事営業・工事事務・工事監理係は工事部で統一
            // 武内・森實・開発・ＯＳ・ＪＳは管理部で統一
            // それ以外の部署は「その他」で登録するようにする

            // 上林・工事営業・工事事務・工事管理係・クリプラ
            if (this.props.section == 44 || this.props.section == 14 || this.props.section == 42 || this.props.section == 46 || this.props.section == 20) {
                data = {
                    section: 14,
                    date: date.target.value
                }

                // 武内・森實・開発・ＯＳ・ＪＳ
            } else if (this.props.section == 48 || this.props.section == 34 || this.props.section == 7 || this.props.section == 5 || this.props.section == 40) {
                data = {
                    section: 5,
                    date: date.target.value
                }

                // 賃貸
            } else if (this.props.section == 1 || this.props.section == 2 || this.props.section == 3 || this.props.section == 4 || this.props.section == 6 || this.props.section == 17 || this.props.section == 47) {
                data = {
                    section: this.props.section,
                    date: date.target.value
                }
            } else if (this.props.section == 26) {
                data = {
                    section: 47,
                    date: date.target.value
                }
            } else {
                data = {
                    section: 100,
                    date: date.target.value
                }
            }
        } else {
            data = {
                section: this.state.sectionState,
                date: date.target.value
            }
        }
        this.props.Reset();
        this.props.get_monthly(data);
        this.props.get_cash_teller_nowmonthly(data);
        // this.props.get_list(data);
    };


    render() {

        return (
            <div>
                <div>

                    {(() => {
                        if (this.props.section == 10 || this.props.section == 8 || this.props.section == 30 || this.props.section == 23 || this.props.section == 49 || this.props.section == 21  || this.props.section == 32) {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>
                                {shop.map((d: any) => (
                                    <option key={d.tenpoNo} value={d.tenpoNo}>
                                        {d.tenpoName}
                                    </option>
                                ))}
                            </NativeSelect>
                        } else if (this.props.section == 20 || this.props.section == 14 || this.props.section == 44 || this.props.section == 42 || this.props.section == 46 || this.props.section == 52) {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>

                                <option key="14" value="14">
                                    工事部
                                    </option>

                            </NativeSelect>
                        } else if (this.props.section == 1 || this.props.section == 2 || this.props.section == 3 || this.props.section == 4 || this.props.section == 6 || this.props.section == 17 || this.props.section == 47) {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>
                                <option key={this.props.section} value={this.props.section}>
                                    自店舗
                                    </option>

                            </NativeSelect>
                        } else if (this.props.section == 26) {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>
                                <option key={47} value={47}>
                                    中央通り店
                                    </option>

                            </NativeSelect>
                        } else if (this.props.section == 48 || this.props.section == 34 || this.props.section == 7 || this.props.section == 5 || this.props.section == 40) {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>
                                <option key="5" value="5">
                                    管理・開発
                                    </option>

                            </NativeSelect>
                        } else {
                            return <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >
                                <option value={0}></option>
                                <option key="100" value="100">
                                    その他
                                    </option>

                            </NativeSelect>
                        }

                    })()}
                    <input style={{ fontSize: "20px" }} onChange={this.date} value={this.state.selectedDate} type="month" id="month" name="month" />
                    <button className="btn btn btn-danger" style={{ marginLeft: "10px" }} onClick={this.props.GetList} >表示</button>

                    {(() => {
                        if (this.props.cash_teller_nowmonthly[0]) {
                            return <i className="fas fa-check-circle">月次確定済み</i>;
                        } else {
                            return "";
                        }
                    })()}

                    {(() => {

                        if (this.props.cash_teller_monthly[0]) {
                            // 選択している月と取得したデータの月が一致しているかどうか
                            var d1 = new Date(this.props.cash_teller_monthly[0]["confirm_date"]);
                            var d2 = new Date(this.state.selectedDate);
                            var d1Month = d1.getFullYear() * 12 + d1.getMonth();
                            var d2Month = d2.getFullYear() * 12 + d2.getMonth();

                            var month = d2Month - d1Month;

                            if (month == 1) {
                                var dispmoney = this.props.cash_teller_monthly[0].payment_result.toLocaleString();
                                return <span style={{ marginLeft: "500px", fontSize: "25px" }}>繰越金:{dispmoney}円</span>
                            } else {
                                var dispmoney = this.props.cash_teller_monthly[0].payment_result.toLocaleString();
                                return <span style={{ marginLeft: "500px", fontSize: "25px" }}>繰越金(未確定):{dispmoney}円</span>
                            }
                        } else {
                            return <span style={{ marginLeft: "500px", fontSize: "25px" }}>
                                データが存在しません
                            </span>
                        }
                    })()}


                </div>

            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        shops: state.masterReducer.shops,
        user_details: state.masterReducer.user_details,
        cash_tellers_list: state.CashTeller.cash_tellers_list,
        cash_teller_monthly: state.CashTeller.cash_teller_monthly,
        cash_teller_nowmonthly: state.CashTeller.cash_teller_nowmonthly,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_list(state: any) {
            dispatch(CashTeller.get_cash_tellers_list(state))
        },
        get_monthly(state: any) {
            dispatch(CashTeller.get_cash_teller_monthly(state))
        },
        get_cash_teller_nowmonthly(state: any) {
            dispatch(CashTeller.get_cash_teller_nowmonthly(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




